// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"138":"7a134bc9","453":"696006ab","888":"689d42c8"}[chunkId] + ".chunk.js";
};